import AodItem from './AodItem';
import {merge, indexOf, omit, isObject} from "lodash";

// todo ? rename this itemCalls...
// an AodItemList has a set of instantiated items linked to a particular API instance
//
// an AodItem is an API call for a particular DB object  e.g. /project
//  and can have special functionality to access the API (depending on the DB object)
//
// AodObjects may be created from the data returned by an callName
//
// aodItems  =  new AodItemList(myAodService);
// api.aodItem.account.get().then(accounts=>doSomethingWith(accounts));
// const projectData = await api.aodItem.project.get(10);
// todo - ? how is object factory called
// const projectObject = api.getObject(Project, projectData);
// const projectObject = new api.getObject['Project'](projectData);

export default function AodItemList(service)
{
    this.service = service ;
    this.init();
}

AodItemList.prototype = {
    add: function add(name,options)
    {
        this[name] = new AodItem(name, this.service, options);
    },
    init: function init()
    {
        // REST service accessors
        this.add('account', { searchPaths: ['wizardEvents'] });
        this.add('advertiser');
        this.add('template') //??
        this.add('artwork'); // todo?
        this.add('calendar');
        
        this.add('salesSheet', {
            searchPaths: ['salesRep', 'advertiser','account'],
            subItems: ['specAd'],
            hasAssets: true
        });
        this.add('specAd', {
            searchPaths: ['salesSheet', 'metroSpecAd'],
            hasAssets: true,
            // todo ?is this the best place for this
            expandRecord: function(rec){
                AodItem.prototype.expandRecord.call(this,rec);

                try {
                    rec.renderInfo = JSON.parse(rec.renderData);
                } catch {
                    rec.renderInfo = {}; //todo ? flesh out ie. template etc
                }

                // todo AOD is rounding the specAd diemensions to integers so overwrite from
                rec.width = rec.renderInfo.output.width;
                rec.height = rec.renderInfo.output.height;
                var template = rec.renderInfo.template;

                if (!rec.metroSpecAd) {
                    rec.metroSpecAd = isObject(template) ? template.file_base : template;
                }
            }
        });

        this.add('email');   // Fake item for sending emails to the server
        this.add('managedFile', {
            searchPaths: ['advertiser','salesSheet','specAd','project','projectItem'],
            hasAssets: true
        });
        this.add('person', {
                plural:'people',
                searchPaths: ['advertiser','account','productionUnit']
            }
        );
        //this.add('trial');
        //this.add('project', { searchPaths: ['account', 'ownedBy'] });
        //this.add('projectItem', { searchPaths: ['project', 'metroName'] });

        this.add('publication');  // not in poroject system yet

        this.add('history',{
            searchPaths: ['account','advertiser','productionUnit','salesSheet','specAd','project','projectItem'],

            // todo move this out to ../item/history.js
            // TBD change server call to be standard search?
            search:  function(parentId,key, options)  //override
            {
                //options = $.extend({pageSize:-1},options);
                //if (options.pageSize > 0) {
                //    options.pageSize++;
                //}
        
                //var subPath = (key && (_.indexOf(this.searchPaths,key)>=0)) ? '/' + key : '';
                const subPath = (key && (indexOf(this.searchPaths,key)>=0)) ? key : '';
        
                //TBD request object that can handle all omits to prevent conflicst with ajax options
                const request = merge(omit(options,'type'), {
                    //queryPath: this.getQueryPath('search' + subPath, parentId, options)
                    queryPath: this.getQueryPath(subPath, parentId, options)
                });
        
                //var self = this;
                return this.service.submitRequest(request);
                //.then( function(response)
                //{
                //    return self.checkMore(response,options.pageSize);
                //});
            },
            getRecords: function getRecords(data)  //override
            {
                return data[this.name];  // always comes as just an ordered array
            }
        });
        
        //this.add('order', { searchPaths: ['account', 'advertiser','ownedBy','metroReference'] });
    }
};